import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { ImBlog } from "react-icons/im";

function Publications() {
  const articles = [
    {
      title: "OWASP Top 10 - Security Principles",
      link: "https://medium.com/@alfahadiqbal/owasp-top-10-security-principles-32016fcdee49",
      platform: "Medium"
    },
    {
      title: "AI Terms Explained Simply",
      link: "https://medium.com/@alfahadiqbal/ai-terms-explained-simply-77200293b085",
      platform: "Medium"
    }
  ];

  return (
    <Container fluid className="home-about-section" style={{ paddingTop: "70px", paddingBottom: "70px" }}>
      <Container>
        <Row>
          <Col md={12} style={{ textAlign: "center", paddingBottom: "40px" }}>
            <h1 style={{ fontSize: "2.3em", color: "white" }}>
              Latest <strong className="purple">Articles</strong>
            </h1>
            <p style={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "1.1em", marginTop: "10px" }}>
              Check out my latest articles and publications
            </p>
          </Col>
        </Row>
        <Row style={{ justifyContent: "center" }}>
          {articles.map((article, index) => (
            <Col md={8} key={index} style={{ paddingBottom: "20px" }}>
              <Card 
                className="project-card-view publication-card"
                style={{
                  padding: "30px",
                  textAlign: "center"
                }}
              >
                <Card.Body>
                  <Card.Title style={{ color: "white", fontSize: "1.6em", marginBottom: "15px" }}>
                    {article.title}
                  </Card.Title>
                  <Card.Text style={{ color: "rgba(255, 255, 255, 0.7)", marginBottom: "25px", fontSize: "1em" }}>
                    Published on {article.platform}
                  </Card.Text>
                  <Button
                    className="publication-button"
                    variant="primary"
                    href={article.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      backgroundColor: "var(--imp-text-color)",
                      borderColor: "var(--imp-text-color)",
                      padding: "10px 30px",
                      fontSize: "1.1em",
                    }}
                  >
                    <ImBlog style={{ marginBottom: "2px", marginRight: "8px" }} />
                    Read Article
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Publications;

